<app-simple-stacked-bar-chart
  [data]="data"
  [loading]="isLoading"
  [leftLabel]="'charts.labels.tutor' | translate"
  rightLabel="%"
></app-simple-stacked-bar-chart>
